import { render } from "./ContactForm.vue?vue&type=template&id=f19ddeec&scoped=true"
const script = {}

import "./ContactForm.vue?vue&type=style&index=0&id=f19ddeec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Desktop\\prueba\\Blooz\\blooz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f19ddeec"]])

export default __exports__